import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../wayfinder'
/**
* @see \App\Http\Controllers\CollegeController::index
 * @see app/Http/Controllers/CollegeController.php:14
 * @route '/colleges'
 */
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/colleges',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CollegeController::index
 * @see app/Http/Controllers/CollegeController.php:14
 * @route '/colleges'
 */
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CollegeController::index
 * @see app/Http/Controllers/CollegeController.php:14
 * @route '/colleges'
 */
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\CollegeController::index
 * @see app/Http/Controllers/CollegeController.php:14
 * @route '/colleges'
 */
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\CollegeController::show
 * @see app/Http/Controllers/CollegeController.php:52
 * @route '/colleges/{college}'
 */
export const show = (args: { college: number | { id: number } } | [college: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/colleges/{college}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CollegeController::show
 * @see app/Http/Controllers/CollegeController.php:52
 * @route '/colleges/{college}'
 */
show.url = (args: { college: number | { id: number } } | [college: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { college: args }
    }

            if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
            args = { college: args.id }
        }
    
    if (Array.isArray(args)) {
        args = {
                    college: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        college: typeof args.college === 'object'
                ? args.college.id
                : args.college,
                }

    return show.definition.url
            .replace('{college}', String(parsedArgs.college ?? ''))
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CollegeController::show
 * @see app/Http/Controllers/CollegeController.php:52
 * @route '/colleges/{college}'
 */
show.get = (args: { college: number | { id: number } } | [college: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\CollegeController::show
 * @see app/Http/Controllers/CollegeController.php:52
 * @route '/colleges/{college}'
 */
show.head = (args: { college: number | { id: number } } | [college: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})
const colleges = {
    index: Object.assign(index, index),
show: Object.assign(show, show),
}

export default colleges